import PureLoadable from 'react-17-pure-loadable';

const ManuallyAddedSkillsValidationLoadable = PureLoadable({
  loader: () => import('./ManuallyAddedSkillsValidation.jsx'),
  displayName: 'ManuallyAddedSkillsValidation',
});

export default ManuallyAddedSkillsValidationLoadable;
